export function FullPageLoader({ label }: { label: string }) {
  return (
    <main className="full-page-loader" aria-live="polite">
      <span className="spinner" />
      <strong>{label}</strong>
    </main>
  )
}
